var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.934,
    height: 17.297,
    viewBox: "0 0 17.934 17.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telephone",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M17.247,12.443a7.794,7.794,0,0,0-3.393-2.407,13.277,13.277,0,0,0-9.76-.015,7.791,7.791,0,0,0-3.4,2.4,3.077,3.077,0,0,0-.553,2.828A1.482,1.482,0,0,0,1.56,16.27l2.24,0h0a1.5,1.5,0,0,0,1.152-.537,1.472,1.472,0,0,0,.321-1.21c0-.013-.005-.025-.008-.038l-.118-.458a9.139,9.139,0,0,1,3.821-.9,9.382,9.382,0,0,1,3.819.922l-.12.456c0,.013-.006.026-.009.039a1.472,1.472,0,0,0,.317,1.211,1.5,1.5,0,0,0,1.153.54l2.24,0h0a1.482,1.482,0,0,0,1.421-1.02A3.08,3.08,0,0,0,17.247,12.443Zm-.473,2.5a.421.421,0,0,1-.4.279h0l-2.24,0a.429.429,0,0,1-.331-.154.4.4,0,0,1-.09-.317l.223-.848a.535.535,0,0,0-.248-.6,10.36,10.36,0,0,0-4.71-1.251H8.932a10.158,10.158,0,0,0-4.679,1.232.535.535,0,0,0-.248.595l.218.849a.4.4,0,0,1-.091.317A.429.429,0,0,1,3.8,15.2h0l-2.24,0a.421.421,0,0,1-.4-.28,2.024,2.024,0,0,1,.4-1.87c1.221-1.67,4.331-2.88,7.4-2.88h.017c3.073,0,6.188,1.225,7.407,2.9A2.027,2.027,0,0,1,16.774,14.946Z",
    transform: "translate(0 -9.1)",
    fill: "#8f768f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(1.872 6.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M65.59,192.075l-1.671-1.754a.535.535,0,0,0-.388-.166h-1.08v-.729a.535.535,0,1,0-1.07,0v.729H59.669v-.729a.535.535,0,1,0-1.07,0v.729h-1.08a.535.535,0,0,0-.388.166l-1.67,1.754a7.332,7.332,0,0,0-2.031,5.078v2.2a.535.535,0,0,0,.535.535H67.086a.535.535,0,0,0,.535-.535v-2.2A7.331,7.331,0,0,0,65.59,192.075ZM54.5,198.819v-1.666a6.266,6.266,0,0,1,1.736-4.34l1.512-1.588H63.3l1.512,1.588a6.266,6.266,0,0,1,1.736,4.34v1.666Z",
    transform: "translate(-53.43 -188.89)",
    fill: "#8f768f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(6.166 9.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M178.847,287.135a2.8,2.8,0,1,0,2.8,2.8A2.8,2.8,0,0,0,178.847,287.135Zm0,4.531a1.73,1.73,0,1,1,1.73-1.73A1.732,1.732,0,0,1,178.847,291.666Z",
    transform: "translate(-176.046 -287.135)",
    fill: "#8f768f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.54d72ec7539b2ddb449335142edeb014.svg";
export { ForwardRef as ReactComponent };